import { ChangeEvent } from 'react';

// third-party
import { useTranslation } from 'react-i18next';

// material-ui
import CardMedia from '@mui/material/CardMedia';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project-imports
import MainCard from 'components/MainCard';
import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';
import { handlerDrawerOpen } from 'api/menu';

// assets
import defaultLayout from 'assets/images/customization/ltr.svg';
import horizontalLayout from 'assets/images/customization/horizontal.svg';
import miniMenu from 'assets/images/customization/mini-menu.svg';

const layouts = [
  { value: MenuOrientation.VERTICAL, labelKey: 'settingsPane.themeLayout.default', img: defaultLayout },
  { value: MenuOrientation.HORIZONTAL, labelKey: 'settingsPane.themeLayout.horizontal', img: horizontalLayout },
  { value: MenuOrientation.MINI_VERTICAL, labelKey: 'settingsPane.themeLayout.miniDrawer', img: miniMenu }
];

// ==============================|| CUSTOMIZATION - THEME LAYOUT/ORIENTATION ||============================== //

export default function ThemeLayout() {
  const { t } = useTranslation();
  const {
    state: { menuOrientation },
    setField
  } = useConfig();

  const handleRadioChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setField('menuOrientation', newValue as MenuOrientation);
    handlerDrawerOpen(newValue === MenuOrientation.MINI_VERTICAL ? false : true);
  };

  const activeCardStyle = { borderColor: 'primary.main' };

  const renderLayoutCard = ({ value: layoutValue, labelKey, img }: any) => (
    <FormControlLabel
      key={layoutValue}
      value={layoutValue}
      sx={{ width: 1, m: 0, display: 'flex' }}
      control={<Radio sx={{ display: 'none' }} />}
      label={
        <Stack sx={{ gap: 0.5, alignItems: 'center' }}>
          <MainCard content={false} sx={{ borderWidth: 2, p: 1, ...(menuOrientation === layoutValue && { ...activeCardStyle }) }}>
            <CardMedia component="img" src={img} alt={t(labelKey)} />
          </MainCard>
          <Typography variant="caption">{t(labelKey)}</Typography>
        </Stack>
      }
    />
  );

  return (
    <RadioGroup row aria-label="theme-layout" name="theme-layout" value={menuOrientation} onChange={handleRadioChange}>
      <Stack direction="row" sx={{ gap: 2.5, alignItems: 'center', width: '100%' }}>
        {layouts.map((layout) => renderLayoutCard(layout))}
      </Stack>
    </RadioGroup>
  );
}
